import { MockFactory } from '@tino-frontend/mocks'
import { BillLIneItemGroup } from '@types'

import { lineItemInstallment } from '@fixtures/apis/bill/line-item/installment'
import { lineItemInstallmentCanceled } from '@fixtures/apis/bill/line-item/installment-canceled'
import { lineItemInstallmentReimbursed } from '@fixtures/apis/bill/line-item/installment-reimbursed'
import { lineItemInstallmentEdited } from '@fixtures/apis/bill/line-item/installment-edited'
import { lineItemInstallmentNumber } from '@fixtures/apis/bill/line-item/installment-number'

import { lineItemDebitChargebacktMock } from '@fixtures/apis/bill/line-item/debt-chargeback'
import { lineItemDebitPurchaseMock } from '@fixtures/apis/bill/line-item/debt-purchase'
import { lineItemDebitFinancingMock } from '@fixtures/apis/bill/line-item/debt-financing-snooze'
import { lineItemDebitFineMock } from '@fixtures/apis/bill/line-item/debt-fine'
import { lineItemDebitFineAggregateMock } from '@fixtures/apis/bill/line-item/debt-fine-aggregate'

import { lineItemCashinReceivableAggregateMock } from '@fixtures/apis/bill/line-item/aggregate-cash-in-receivable'

import { lineItemBalanceMock } from '@fixtures/apis/bill/line-item/cash-in-balance'
import { lineItemCashinCreditMock } from '@fixtures/apis/bill/line-item/cash-in-credit'
import { lineItemCashinFinancingMock } from '@fixtures/apis/bill/line-item/cash-in-financing'
import { lineItemCashinPaymentMock } from '@fixtures/apis/bill/line-item/cash-in-payment'
import { lineItemCashinReceivableMock } from '@fixtures/apis/bill/line-item/cash-in-receivable'
import { lineItemProcessingPurchaseMock } from '@fixtures/apis/bill/line-item/processing-purchase'
import { lineItemDebtChargebackAggregateMock } from '@fixtures/apis/bill/line-item/debt-chargeback-aggregate'

const allLineItems: BillLIneItemGroup[] = [
  { line_items: [lineItemInstallment.build()], is_paid: false }, // 0
  { line_items: [lineItemInstallmentCanceled.build()], is_paid: false }, // 1
  { line_items: [lineItemInstallmentEdited.build()], is_paid: false }, // 2
  { line_items: [lineItemInstallmentNumber.build()], is_paid: false }, // 3

  { line_items: [lineItemDebitChargebacktMock.build()], is_paid: false }, // 4
  { line_items: [lineItemDebitPurchaseMock.build()], is_paid: false }, // 5
  { line_items: [lineItemDebitFinancingMock.build()], is_paid: false }, // 6
  { line_items: [lineItemDebitFineMock.build()], is_paid: false }, // 7
  { line_items: [lineItemDebitFineAggregateMock.build()], is_paid: false }, // 8

  {
    line_items: [lineItemCashinReceivableAggregateMock.build()],
    is_paid: false,
  }, // 9

  { line_items: [lineItemBalanceMock.build()], is_paid: false }, // 10

  { line_items: [lineItemCashinCreditMock.build()], is_paid: false }, // 11
  { line_items: [lineItemCashinFinancingMock.build()], is_paid: false }, // 12
  { line_items: [lineItemCashinPaymentMock.build()], is_paid: false }, // 13
  { line_items: [lineItemCashinReceivableMock.build()], is_paid: false }, // 14
  { line_items: [lineItemInstallmentReimbursed.build()], is_paid: false }, // 15

  { line_items: [lineItemProcessingPurchaseMock.build()], is_paid: false }, // 16
  { line_items: [lineItemDebtChargebackAggregateMock.build()], is_paid: false }, // 17
]

export const allLineItemsMock = new MockFactory<BillLIneItemGroup[]>(
  allLineItems
)
